import React, { useContext, useState } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import '../styles/App.css';
import Navbar from './Navbar';
import Home from './Home';
import PartyHistory from './PartyHistory';
import Login from './Login'
import AuthContext from '../contexts'

import MyPicks from './MyPicks';
import CreateParty from './CreateParty';
import SetWinners from './SetWinners';
import UpdateParty from './UpdateParty';
import ViewParty from './ViewParty';
import { CacheContext } from '../contexts';

const App = () => {
    const { user, isLoggedIn } = useContext(AuthContext);
    const { activeParty } = useContext(CacheContext);

    const [isShowtime, setIsShowtime] = useState(false);

    const showTimeInterval = setInterval(() => {
        const startTime = Date.now() / 1000; // use UNIX timestamp in seconds
        const endTime = new Date(process.env.REACT_APP_OSCAR_DATE || "2026-03-15T18:00:00-06:00").getTime() / 1000;
        const remainingTime = endTime - startTime;
        if (remainingTime <= 0) {
            setIsShowtime(true);
            clearInterval(showTimeInterval);
        }
    }, 1000);


    return (
        <Router>
            <Navbar isShowtime={isShowtime} />

            <Routes>


                <Route
                    path="/login"
                    element={<Login />}
                />
                {
                    isLoggedIn
                        ?
                        <>
                            <Route
                                path='/'
                                element={<Home />}
                            />

                            <Route
                                path='/party-history'
                                element={<PartyHistory />}
                            />

                            {
                                !isShowtime && !activeParty?.isHistory && activeParty?.id
                                    ?
                                    <Route
                                        path='/my-picks/:partyId'
                                        element={<MyPicks />}
                                    />

                                    :
                                    <></>
                            }

                            <Route
                                path="/party/create"
                                element={<CreateParty />}
                            />

                            <Route
                                path="/party/view/:partyId"
                                element={<ViewParty isShowtime={isShowtime} />}
                            />              

                            {
                                user && user.email == 'jasonmonroe417@gmail.com'
                                    ?
                                    <Route
                                        path='/set-winners'
                                        element={<SetWinners />}
                                    />
                                    :
                                    <></>
                            }
                            {
                                 user && user.email==activeParty?.adminEmail && !activeParty?.isHistory
                                    ?
                                    <Route
                                        path='/party/update/:partyId'
                                        element={<UpdateParty />}
                                    />
                                    :
                                    <></>
                            }

                        </>
                        :
                        <>
                            <Route
                                path='/'
                                element={<Login />}
                            />

                        </>

                }

            </Routes>
        </Router>
    );
};


export default App;
